/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
      document.addEventListener('DOMContentLoaded', function () {
        function patchLoopBadges() {
      document.querySelectorAll('.loop-widget-purchase-option-discount-badge').forEach(function (badge) {
        var wrapper = badge.closest('.loop-widget-spg-label-discount-wrapper') || badge.parentElement;
        var label = wrapper && wrapper.querySelector('.loop-widget-purchase-option-label');

        // NOTE: "$7" is hardcoded here. If the 3-Month Minimum plan's monthly
        // discount amount ever changes in Loop's Selling Plans settings, this
        // text must be updated manually to match — it will not update on its own.
        if (
          label &&
          label.textContent.trim() === '3-Month Minimum' &&
          badge.textContent.trim() !== 'FIRST BOX FREE · THEN SAVE $7/BOX'
        ) {
          badge.textContent = 'FIRST BOX FREE · THEN SAVE $7/BOX';
        }

        // NOTE: "$4" is hardcoded here. If the Month-to-Month plan's monthly
        // discount amount ever changes in Loop's Selling Plans settings, this
        // text must be updated manually to match — it will not update on its own.
        if (
          label &&
          label.textContent.trim() === 'Month-to-Month' &&
          badge.textContent.trim() !== 'Save $4/BOX'
        ) {
          badge.textContent = 'Save $4/BOX';
        }
      });
    }
    new MutationObserver(patchLoopBadges).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    patchLoopBadges();
  });


  
    document.addEventListener('DOMContentLoaded', function() {
    
      let subGiftButtons = document.querySelectorAll(".givy_send_as_gift_button");
      subGiftButtons.forEach(button => {
        const variantId = button.dataset.variantId; 
        const planId = button.dataset.planId; 
        button.addEventListener('click', function(e) {
          e.preventDefault();
          GIVY.displayModal(variantId, {
             displaySubscriptionOptions: true,
             initialSelectedSellingPlanId:planId,
             addToCartSuccessCallback: function() {
                document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
             } 
          });
        });
    
      });

        let subButtons = document.querySelectorAll(".subscribe");
        subButtons.forEach(button => {
          button.addEventListener('click', function(e) {
            e.preventDefault();
            document.dispatchEvent(
              new CustomEvent('theme:cart:add', {
                detail: {
                  button: button,
                },
                bubbles: true,
              })
            );
          });
        });
    

    
      
    }); 



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
/* Exclude subscription selling plans from free shipping progress */
/* Exclude subscription selling plans from free shipping progress */
/* Exclude subscription selling plans from free shipping progress */
(function () {
  const excludedSellingPlanIds = [
    '693827010874',
    '693828485434',
    '693828518202',
    '693828550970'
  ];

  const progressCircleCircumference = 28 * Math.PI;

  function getSellingPlanId(item) {
    return String(
      item?.selling_plan_allocation?.selling_plan?.id ||
      item?.selling_plan_allocation?.selling_plan_id ||
      item?.selling_plan ||
      ''
    );
  }

  function getEligibleSubtotal(cart) {
    return cart.items.reduce(function (total, item) {
      const sellingPlanId = getSellingPlanId(item);
      const isExcludedSubscription = excludedSellingPlanIds.includes(sellingPlanId);

      if (isExcludedSubscription) {
        return total;
      }

      return total + (item.final_line_price || item.line_price || 0);
    }, 0);
  }

  function formatCartMoney(cents) {
    const moneyFormat = theme.moneyFormat || '${{amount}}';
    return window.theme.formatMoney(cents, moneyFormat).replace('.00', '');
  }

  function updateFreeShippingProgress() {
    const freeShippingBlocks = document.querySelectorAll('[data-free-shipping]');

    if (!freeShippingBlocks.length) {
      return;
    }

    fetch('/cart.js?t=' + Date.now())
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        const eligibleSubtotal = getEligibleSubtotal(cart);

        freeShippingBlocks.forEach(function (block) {
          const rawLimit = Number(block.getAttribute('data-free-shipping-limit')) || 0;
          const currencyRate = window.Shopify?.currency?.rate || 1;
          const freeShippingLimit = rawLimit * 100 * currencyRate;

          if (!freeShippingLimit) {
            return;
          }

          const amountLeft = Math.max(freeShippingLimit - eligibleSubtotal, 0);
          const progress = Math.min((eligibleSubtotal / freeShippingLimit) * 100, 100);
          const strokeOffset = progressCircleCircumference - (progress / 100) * progressCircleCircumference / 2;

          const leftToSpend = block.querySelector('[data-left-to-spend]');
          const progressBar = block.querySelector('[data-progress-bar]');
          const progressGraph = block.querySelector('[data-progress-graph]');

          block.classList.toggle('is-success', eligibleSubtotal >= freeShippingLimit);

          if (leftToSpend) {
            leftToSpend.innerHTML = formatCartMoney(amountLeft);
          }

          if (progressBar) {
            progressBar.value = progress;
          }

          if (progressGraph) {
            progressGraph.style.setProperty('--stroke-dashoffset', strokeOffset);
          }
        });
      })
      .catch(function (error) {
        console.warn('Free shipping progress update failed:', error);
      });
  }

  function scheduleFreeShippingUpdate() {
    setTimeout(updateFreeShippingProgress, 100);
    setTimeout(updateFreeShippingProgress, 300);
    setTimeout(updateFreeShippingProgress, 750);
    setTimeout(updateFreeShippingProgress, 1500);
  }

  document.addEventListener('DOMContentLoaded', scheduleFreeShippingUpdate);
  document.addEventListener('theme:cart:change', scheduleFreeShippingUpdate);
  document.addEventListener('theme:product:added', scheduleFreeShippingUpdate);
  document.addEventListener('theme:cart-drawer:open', scheduleFreeShippingUpdate);
  document.addEventListener('theme:announcement:init', scheduleFreeShippingUpdate);
  document.addEventListener('shopify:section:load', scheduleFreeShippingUpdate);

  const observer = new MutationObserver(function () {
    scheduleFreeShippingUpdate();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();